import React, { useEffect, useState } from "react";
import Quizhome from "./Components/Quiezhome/Quizhome";
import Layout from "./Components/Routing/Routingpage";
import Routingpage from "./Components/Routing/Routingpage";
import { PrimeReactProvider, PrimeReactContext } from "primereact/api";
import "primereact/resources/themes/saga-blue/theme.css"; // Theme
import "primereact/resources/primereact.min.css"; // Core CSS
import { RecoilRoot } from "recoil";
import ChatBot from "./Components/ChatBot/ChatBot";
import { BrowserRouter, Link, useLocation } from "react-router-dom";
import { LoadingPage } from "./Components/LoadingPage/LoadingPage";
import Lottie from "react-lottie";
import animationData from "./Assets/lottie/bot-animation-hello.json";
import i18n from "./i18n";

const App = () => {
  const [showModal, setShowModal] = useState(false);

  const pathname = useLocation().pathname;

  console.log(pathname, "pathname");

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  useEffect(() => {
    if (
      pathname !== "/detail_result_page" &&
      (localStorage.getItem("lang") !== "en" &&
        localStorage.getItem("lang") !== "ar")
    ) {
      localStorage.setItem("lang", "en");
      i18n.changeLanguage("en");
    }
  }, [pathname]);

  return (
    <RecoilRoot>
      <PrimeReactProvider>
        <React.Suspense fallback={<LoadingPage />}>
          <div onClick={() => setShowModal(false)}>
            <Routingpage />
          </div>
        </React.Suspense>

        <ChatBot setShowModal={setShowModal} showModal={showModal} />
        <Link
          to={"/ai-agent"}
          className={`fixed group z-[100] bottom-0 right-0 ${
            pathname === "/ai-agent" ||
            pathname === "/result-page" ||
            pathname === "/rough" ||
            pathname === "/home"
              ? "hidden"
              : ""
          }`}
        >
          <Lottie options={defaultOptions} height={150} width={150} />
        </Link>
      </PrimeReactProvider>
    </RecoilRoot>
  );
};

export default App;
